import React, { Fragment, memo } from 'react';
import { useColumnCover } from '../../hooks/table';
import { TableRow } from './TableRow';
export var TableRowGroup = memo(function (props) {
  var onRow = props.onRow,
      rowClassName = props.rowClassName,
      rowInfos = props.rowInfos;
  var coverLeft = useColumnCover('left');
  var coverRight = useColumnCover('right');
  var rows = rowInfos.map(function (rowInfo, index) {
    var path = rowInfo.path;
    return React.createElement(TableRow, {
      key: "Row-".concat(path.join('-')),
      rowInfo: rowInfo,
      coverLeft: coverLeft,
      coverRight: coverRight,
      rowClassName: rowClassName,
      onRow: onRow
    });
  });
  return React.createElement(Fragment, null, rows);
});